import React, { useState, useEffect } from "react";
import { FaCamera } from "react-icons/fa";
import api from "../../services/apiService";
import { InputComponent, ButtonComponent, Modal, SelectInput } from "../ui";

const CreateDataBaseModal = ({
  show,
  handleClose,
  setNotification,
  setStatus,
  fetchData,
}) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    email2: "",
    companyName: "",
    industry: "",
    linkedIn: "",
    headAccount: "",
    location: "",
    jobTitle: "",
  });

  const [headAccounts, setHeadAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch industries and head accounts when modal opens
  useEffect(() => {
    if (show) {
      fetchHeadAccounts();
    }
  }, [show]);

  const fetchHeadAccounts = async () => {
    try {
      const response = await api.get("/fetch-head-accounts");
      const headAccountsData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      setHeadAccounts(headAccountsData);
    } catch (error) {
      console.error("Error fetching head accounts:", error);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await api.post("/create-newdatabase", form);
      setStatus(true);
      setNotification("Database entry created successfully!");
      setForm({
        name: "",
        email: "",
        email2: "",
        companyName: "",
        industry: "",
        linkedIn: "",
        headAccount: "",
        location: "",
        jobTitle: "",
      });
      handleClose();
      fetchData();
    } catch (error) {
      console.error("Error creating database entry:", error);
      setStatus(false);
      setNotification("Failed to create database entry!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onClose={handleClose} title="Add Database">
      {/* Avatar */}
      <div className="flex justify-center mb-6">
        <div className="w-24 h-24 flex items-center justify-center rounded-full bg-gray-100">
          <FaCamera size={56} />
        </div>
      </div>

      {/* Form */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-lg">
        {/* Head Account (FTE) Dropdown */}
        <div>
          <label className="block mb-1" htmlFor="headAccount">
            Head Account
          </label>
          <SelectInput
            name="headAccount"
            className="w-full"
            title="Head Account (FTE)"
            value={form.headAccount}
            onChange={handleChange}
            required
          >
            <option value="">Select FTE</option>
            {headAccounts.map((account) => (
              <option key={account.id} value={account.id}>
                {account.count || account.headAccount}
              </option>
            ))}
          </SelectInput>
        </div>

        {/* Other Inputs */}
        {[
          { label: "Name", key: "name" },
          { label: "Email", key: "email" },
          { label: "Email2", key: "email2" },
          { label: "Company Name", key: "companyName" },
          { label: "Job Title", key: "jobTitle" },
          { label: "Location", key: "location" },
          { label: "LinkedIn", key: "linkedIn" },
          { label: "Industry", key: "industry" },
        ].map(({ label, key }) => (
          <div key={key}>
            <label className="block mb-1">{label}</label>
            <InputComponent
              name={key}
              type="text"
              className="w-full"
              value={form[key]}
              onChange={handleChange}
              required
            />
          </div>
        ))}
      </div>

      {/* Actions */}
      <div className="flex justify-end mt-8 gap-3">
        <ButtonComponent
          className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </ButtonComponent>
        <ButtonComponent
          className="px-6 py-2 bg-[#2470B7] hover:bg-[#2470B7] text-white rounded"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </ButtonComponent>
      </div>
    </Modal>
  );
};

export default CreateDataBaseModal;
